import React from 'react';
import { API, Logger, graphqlOperation } from 'aws-amplify';
import { getDatasetTables } from '../../../graphql/queries';

const logger = new Logger('useDatasetTables');

function reducer(state, action) {
  switch (action.type) {
    case "LOADING":
      return { ...state, loading: action.payload };
    case "ERROR":
      return { ...state, error: action.payload };
    case "INSERT":
      return { ...state, tables: [...state.tables, ...action.payload] };
    default:
      throw new Error();
  }
}

export const useDatasetTables = (props) => {

  const [state, dispatch] = React.useReducer(reducer, { 
    tables: [],
    loading: true,
    error: null
  });
  
  const { resourceId, debug } = props;
  
  React.useEffect(() => {
    let unmounted = false;
    let variables = { resourceId: resourceId };

    API.graphql(graphqlOperation(getDatasetTables,variables))
      .then(res => res.data.getDatasetTables)
      .then(raw => {
        if(!unmounted) {
          const glueGetTablesResponse = JSON.parse(raw);
          if(glueGetTablesResponse.TableList) {
            logger.debug("DATASET TABLES: ",glueGetTablesResponse.TableList);
            dispatch({ type: 'INSERT', payload: glueGetTablesResponse.TableList});
          }
          if(glueGetTablesResponse.NextToken) {
            logger.warning("Incomplete table list response... continuation not implemented.");
          }
          dispatch({ type: 'LOADING', payload: false});
        }
      })
      .catch(err => {
        if(!unmounted) {
          dispatch({ type: 'ERROR', payload: err});
          dispatch({ type: 'LOADING', payload: false});
        }
      });

    return () => { 
      logger.debug("useDatasetTables cleanup!");
      unmounted = true;
    };

  }, [resourceId, debug]);
  
  return { 
    tables: state.tables,
    loading: state.loading,
    error: state.error
  };
};

